import gesconMenu from './app/gescon/menu'

export default {
    items: [
        {
            name: 'Dashboard',
            url: '/dashboard',
            icon: 'icon-speedometer'
        },
        {
            name: 'Pagamentos',
            url: '/fornecedor/pagamentos',
            icon: 'fa fa-dollar',
            regras: 'FORN-PAG-00'
        },
        gesconMenu,
        {
            name: 'Dados Cadastrais',
            url: '/fornecedor/dadoscadastrais',
            icon: 'fa fa-info-circle',
            regras: 'FORN-DADOS-00'
        },
        {
            name: 'Certidões',
            url: '/fornecedor/certidoes',
            icon: 'fa fa-file-text-o',
            regras: 'FORN-CERT-00'
        },
        {
            name: 'Rendimentos Anuais',
            url: '/fornecedor/dirfs',
            icon: 'fa fa-money',
            regras: 'FORN-DIRF-00'
        },
        {
            name: 'Usuários',
            url: '/fornecedor/usuarios',
            icon: 'fa fa-users',
            regras: 'FORN-USR-00'
        },
        {
            name: 'Admin',
            url: '/admin',
            icon: 'fa fa-cog',
            badge: {
                variant: 'primary',
                text: ''
            },
            regras: ['ADMIN-JOBS-00', 'ADMIN-PARAMETROS-00'],
            children: [
                {
                    name: 'Jobs',
                    url: '/admin/jobs',
                    icon: 'fa fa-calendar-o',
                    regras: 'ADMIN-JOBS-00'
                },
                {
                    name: 'Parâmetros',
                    url: '/admin/parametros',
                    icon: 'fa fa-cogs',
                    regras: 'ADMIN-PARAMETROS-00'
                }
            ]
        },
        {
            name: 'Proposta de Preço',
            url: '/propostas-precos',
            icon: 'fa fa-money',
            regras: [
                'PROP-PRECO-OBTER-00'
            ]
        },
        {
            name: 'Controle de Acesso',
            url: '/controleacesso',
            icon: 'fa fa-vcard-o',
            regras: [
                'CTRLACS-USR-00',
                'CTRLACS-PA-00',
                'CTRLACS-RA-00',
                'CTRLACS-SOLACS-00'
            ],
            children: [
                {
                    name: 'Usuários',
                    url: '/controleacesso/usuarios',
                    icon: 'fa fa-users',
                    regras: 'CTRLACS-USR-00'
                },
                {
                    name: 'Solicitações de Acesso',
                    url: '/controleacesso/solicitacoesacesso',
                    icon: 'fa fa-user-plus',
                    regras: 'CTRLACS-SOLACS-00'
                },
                {
                    name: 'Perfis de Acesso',
                    url: '/controleacesso/perfisacesso',
                    icon: 'fa fa-user-secret',
                    regras: 'CTRLACS-PA-00'
                },
                {
                    name: 'Regras de Acesso',
                    url: '/controleacesso/regrasacesso',
                    icon: 'fa fa-key',
                    regras: 'CTRLACS-RA-00'
                },
                {
                    name: 'Aplicações',
                    url: '/controleacesso/aplicacoes',
                    icon: 'fa fa-code',
                    regras: 'CTRLACS-APP-00'
                }
            ]
        },
        {
            name: 'Fornecedores',
            url: '/fornecedores',
            icon: 'fa fa-building-o',
            regras: ['GEST-DADOS-00']
        },
        {
            name: 'Atualizações Cadastrais',
            url: '/atualizacoescadastrais',
            icon: 'fa fa-info-circle',
            regras: 'GEST-DADOS-00'
        },
        {
            name: 'DIRFs',
            url: '/dirfs',
            icon: 'fa fa-money',
            badge: {
                variant: 'primary',
                text: ''
            },
            regras: ['DIRFS-00']
        },
        {
            name: 'Mensagens',
            url: '/mensagens',
            icon: 'fa fa-envelope',
            regras: 'MENSAGENS-00'
        },
        {
            name: 'Relatórios',
            url: '/relatorios',
            icon: 'fa fa-file-text-o',
            regras: 'RELATORIOS-00'
        },
        {
            name: 'Base de Conhecimento',
            url: '/baseconhecimento',
            icon: 'fa fa-graduation-cap'
        }
    ]
}
